'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Chat = require('./Chat.scss');

var _Chat2 = _interopRequireDefault(_Chat);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

var _actions = require('redux/modules/booking/actions');

var _payment = require('redux/modules/payment');

var _trip = require('redux/modules/trip');

var _reactRouterRedux = require('react-router-redux');

var _SelectPeople = require('components/General/FormElements/SelectPeople');

var _SelectPeople2 = _interopRequireDefault(_SelectPeople);

var _Calendar = require('containers/Calendar/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _LoadingButton = require('components/Loader/LoadingButton');

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _pluralize = require('pluralize');

var _pluralize2 = _interopRequireDefault(_pluralize);

var _media = require('utils/media');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Chat: {
    displayName: 'Chat'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Chat.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import CustomSelect from '../General/FormElements/CustomSelect';

// import LoginSignup from 'components/Nav/LoginSignup';


_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var Chat = _wrapComponent('Chat')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoggedIn: state.session.isLoggedIn,
    // selectedDate: state.calendar.selected.day,
    tripDate: state.payment.date,
    paymentError: state.payment.error,
    acceptSwap: state.payment.acceptSwap,
    tripDateStatus: state.payment.dateStatus,
    sessionData: state.session.data,
    user: state.session.user,
    sending: state.booking.sending,
    creating: state.booking.creating,
    requestId: state.payment.requestId,
    messages: state.language.messages
  };
}, {
  setSessionData: _session.setSessionData,
  setLocalSessionData: _session.setLocalSessionData,
  createBooking: _actions.createBooking,
  sendMessage: _actions.sendMessage,
  activateBooking: _actions.activateBooking,
  push: _reactRouterRedux.push,
  openLoginSignup: _session.openLoginSignup,
  setLoginSignupCallback: _session.setLoginSignupCallback,
  openChat: _trip.openChat,
  clickSendMessage: _payment.clickSendMessage,
  paymentOpenLoginSignup: _payment.paymentOpenLoginSignup,
  setPaymentField: _payment.setField,
  setPaymentError: _payment.setError,
  logAcceptSwap: _payment.logAcceptSwap,
  logSetDate: _payment.logSetDate
}), _dec2 = (0, _reactCssModules2.default)(_Chat2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Chat, _Component);

  function Chat() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Chat);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chat.__proto__ || (0, _getPrototypeOf2.default)(Chat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openDatePicker: false,
      message: ''
    }, _this.onChangeMessage = function (event) {
      _this.setState({ message: event.target.value });
    }, _this.onSendMessage = function () {
      if (_this.validateForm()) {
        _this.props.clickSendMessage(_this.props.requestId);
        if (_this.props.isLoggedIn) {
          _this.sendMessage();
        } else {
          // this.setState({openLoginSignup: true});
          _this.props.openLoginSignup();
          _this.props.paymentOpenLoginSignup(); // for logging
          _this.props.setLoginSignupCallback(_this.sendMessage);
        }
      }
    }, _this.getMaxTravelerOption = function () {
      var max_travelers = _this.props.trip.max_travelers;

      return _lodash2.default.fill(Array(max_travelers)).map(function (item, index) {
        return index + 1;
      });
    }, _this.getQuantity = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          sessionData = _this$props.sessionData;

      return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
    }, _this.getPredefineText = function () {
      var _this$props2 = _this.props,
          trip = _this$props2.trip,
          tripDate = _this$props2.tripDate;

      var quantity = _this.getQuantity();
      var text = 'Hi';
      if (trip && trip.user_id && trip.user_id.name && trip.user_id.name.first) {
        text += ' ' + trip.user_id.name.first;
      }
      if (tripDate) {
        text += ', I\'m interested in your trip on ' + (0, _momentTimezone2.default)(tripDate).format('Do MMMM YYYY') + ' ';
      } else {
        text += ', I\'m interested in your trip on ... ';
      }
      if (quantity) {
        text += 'with ' + (0, _pluralize2.default)('guest', quantity, true) + '.';
      } else {
        text += 'with ... guest(s).';
      }
      text += ' Please confirm if you are available so I can make the online payment on the website.';
      return text;
    }, _this.setDate = function (date, status) {
      _this.props.setPaymentField('date', date);
      _this.props.setPaymentField('dateStatus', status);
      _this.props.setPaymentError((0, _extends3.default)({}, _this.props.paymentError, { date: false }));
      _this.props.logSetDate(date, status);
      _this.closeDatePicker();
    }, _this.validateForm = function () {
      var pass = true;
      var error = {};
      if (!_this.props.tripDate) {
        error.date = true;
        pass = false;
      }
      if (_this.props.tripDateStatus === 'n/a' && !_this.props.acceptSwap) {
        error.acceptSwap = true;
        pass = false;
      }
      _this.props.setPaymentError(error);
      return pass;
    }, _this.sendMessage = function () {
      var bookingData = {
        trip_id: _this.props.trip._id,
        trip_date: _this.props.tripDate,
        quantity: _this.getQuantity(),
        source: 'message',
        id: _this.props.requestId
      };
      _this.props.createBooking(bookingData).then(function (result) {
        var id = result._id;
        if (_this.refs.message.value) {
          _this.props.sendMessage(id, _this.refs.message.value).then(function () {
            _this.props.openChat(false);
            _this.props.push('/dashboard/booking/' + id);
          });
        } else {
          // this.props.activateBooking(id)
          _this.props.sendMessage(id, _this.getPredefineText()).then(function () {
            _this.props.openChat(false);
            _this.props.push('/dashboard/booking/' + id);
          });
        }
      });
    }, _this.openDatePicker = function () {
      _this.setState({ openDatePicker: true });
    }, _this.closeDatePicker = function () {
      _this.setState({ openDatePicker: false });
    }, _this.toggleAcceptSwap = function () {
      _this.props.setPaymentField('acceptSwap', !_this.props.acceptSwap);
      _this.props.setPaymentError((0, _extends3.default)({}, _this.props.paymentError, { acceptSwap: false }));
      _this.props.logAcceptSwap(!_this.props.acceptSwap);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Chat, [{
    key: 'onChange',
    value: function onChange(name, value, a) {
      this.props.setLocalSessionData({ 'quantity': a });
      this.props.setSessionData({ 'quantity': a });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          openDatePicker = _state.openDatePicker,
          message = _state.message;
      var _props = this.props,
          trip = _props.trip,
          tripDate = _props.tripDate,
          sending = _props.sending,
          creating = _props.creating,
          messages = _props.messages,
          paymentError = _props.paymentError,
          tripDateStatus = _props.tripDateStatus,
          acceptSwap = _props.acceptSwap;

      var lx = trip.user_id;
      var quantity = this.getQuantity();
      return _react3.default.createElement(
        'div',
        { styleName: 'chat-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'mobile-label' },
          _react3.default.createElement(
            'p',
            null,
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'chat-info' },
          _react3.default.createElement('div', { styleName: 'lx-pic', style: (0, _media.path)(lx.avatar_image, 'profileAvatar', true) }),
          _react3.default.createElement(
            'h3',
            { styleName: 'lx-name' },
            lx.name.first,
            ' ',
            lx.name.last
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'city' },
            trip.desination_location
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'topic' },
            _react3.default.createElement('i', { styleName: 'bullet' }),
            _react3.default.createElement(
              'p',
              { styleName: 'topic-content' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q1' })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'topic' },
            _react3.default.createElement('i', { styleName: 'bullet' }),
            _react3.default.createElement(
              'p',
              { styleName: 'topic-content' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q2' })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'topic' },
            _react3.default.createElement('i', { styleName: 'bullet' }),
            _react3.default.createElement(
              'p',
              { styleName: 'topic-content' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q3' })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'chat-content' },
          _react3.default.createElement(
            'div',
            { styleName: 'mobile-scrollable' },
            _react3.default.createElement(
              'div',
              { styleName: 'options' },
              _react3.default.createElement(
                'div',
                { styleName: 'float-parent' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'option' },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'label' },
                    _react3.default.createElement('i', { styleName: 'calendar-icon' }),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'label-text' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.date' }),
                      ':'
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'input-container', onFocus: this.openDatePicker },
                    _react3.default.createElement('input', { type: 'text', styleName: paymentError.date ? 'custom-input-error' : 'custom-input', readOnly: true, value: tripDate ? (0, _momentTimezone2.default)(tripDate).format('LL') : messages['trip.detail.desktop.chat.date.placeholder'] }),
                    _react3.default.createElement(
                      'div',
                      { styleName: 'date-picker', style: openDatePicker ? null : { 'display': 'none' } },
                      _react3.default.createElement(_Calendar2.default, { tripAvailability: true, trip: this.props.trip, onChange: this.setDate, initialDate: tripDate, offsetDay: 1, allowBookOnNA: this.props.trip.is_replaceable })
                    )
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'option' },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'label' },
                    _react3.default.createElement('i', { styleName: 'guest-icon' }),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'label-text' },
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.guest' })
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'input-container' },
                    _react3.default.createElement(_SelectPeople2.default, { options: this.getMaxTravelerOption(), value: quantity > trip.max_travelers ? trip.max_travelers : quantity, onChange: this.onChange.bind(this), fieldName: 'quantity' })
                  )
                )
              ),
              paymentError.acceptSwap ? _react3.default.createElement(
                'div',
                { styleName: 'checkbox-container', style: tripDateStatus === 'n/a' ? null : { display: 'none' } },
                _react3.default.createElement('div', { className: 'summary-check', styleName: acceptSwap ? 'checkbox-error-checked' : 'checkbox-error', onClick: this.toggleAcceptSwap }),
                _react3.default.createElement(
                  'span',
                  { className: 'payment-agree', styleName: acceptSwap ? 'checkbox-label-error-checked' : 'checkbox-label-error', onClick: this.toggleAcceptSwap },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
                )
              ) : _react3.default.createElement(
                'div',
                { styleName: 'checkbox-container', style: tripDateStatus === 'n/a' ? null : { display: 'none' } },
                _react3.default.createElement('div', { className: 'summary-check', styleName: acceptSwap ? 'checkbox-checked' : 'checkbox', onClick: this.toggleAcceptSwap }),
                _react3.default.createElement(
                  'span',
                  { className: 'payment-agree', styleName: acceptSwap ? 'checkbox-label-checked' : 'checkbox-label', onClick: this.toggleAcceptSwap },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
                )
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'chat-box-container' },
              _react3.default.createElement('textarea', { styleName: 'custom-textarea', value: message, readOnly: sending || creating, onChange: this.onChangeMessage, ref: 'message', placeholder: this.getPredefineText() })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'btn-container' },
            sending || creating ? _react3.default.createElement(
              'a',
              { styleName: 'btn-send-msg-loading' },
              _react3.default.createElement(_LoadingButton2.default, null),
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.sending' })
            ) : _react3.default.createElement(
              'a',
              { styleName: 'btn-send-msg', onClick: this.onSendMessage },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
            )
          )
        )
      );
    }
  }]);
  return Chat;
}(_react2.Component), _class2.propTypes = {
  onClose: _react2.PropTypes.func,
  trip: _react2.PropTypes.object,
  isLoggedIn: _react2.PropTypes.bool,
  setPaymentField: _react2.PropTypes.func,
  setPaymentError: _react2.PropTypes.func,
  acceptSwap: _react2.PropTypes.bool,
  paymentError: _react2.PropTypes.object,
  // selectedDate: PropTypes.object,
  tripDate: _react2.PropTypes.any,
  tripDateStatus: _react2.PropTypes.string,
  sessionData: _react2.PropTypes.object,
  setSessionData: _react2.PropTypes.func,
  setLocalSessionData: _react2.PropTypes.func,
  createBooking: _react2.PropTypes.func,
  sendMessage: _react2.PropTypes.func,
  activateBooking: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  user: _react2.PropTypes.object,
  openLoginSignup: _react2.PropTypes.func,
  setLoginSignupCallback: _react2.PropTypes.func,
  clickSendMessage: _react2.PropTypes.func,
  sending: _react2.PropTypes.bool,
  creating: _react2.PropTypes.bool,
  openChat: _react2.PropTypes.func,
  requestId: _react2.PropTypes.string,
  paymentOpenLoginSignup: _react2.PropTypes.func,
  logAcceptSwap: _react2.PropTypes.func,
  logSetDate: _react2.PropTypes.func,
  messages: _react2.PropTypes.object
}, _temp2)) || _class) || _class));

exports.default = Chat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Chat.js
// module id = 1629
// module chunks = 0